import fetch from "@/utils/fetch";
// import { getToken } from "@/utils/auth";
// import { stringify } from "qs";

const API_SMART = window.SERVERAPI.API_SMART;
const API_BASE = window.SERVERAPI.API_BASE;
// ai搜索-获取词关系图
export function getGraphChartData(data) {
  return fetch({
    baseURL: API_SMART,
    url: "/AiSearch/AISearchWordRelation",
    method: "post",
    data,
  });
}
// 全文检索
export function GetArticleList(data) {
  return fetch({
    baseURL: API_SMART,
    url: "/Search/GetArticleList",
    method: "post",
    data,
  });
}
// 文章详情
export function GetArticle(params) {
  return fetch({
    baseURL: API_SMART,
    url: "/Search/GetArticle",
    method: "get",
    params,
  });
}
//AI检索主题列表
export function SearchAITopicList(data) {
  return fetch({
    baseURL: API_SMART,
    url: "/AiSearch/SearchAITopicList",
    method: "post",
    data,
  });
}
//AI分析
export function AISearchAnalyse(data) {
  return fetch({
    baseURL: API_SMART,
    url: "/AiSearch/AISearchAnalyse",
    method: "post",
    data,
  });
}
// AI分析新接口
export function GetAiAdvancedEvent(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/GetAiAdvancedEvent",
    method: "post",
    data,
  });
}
//获取省市数据
export function GetProvinceCity(params) {
  return fetch({
    baseURL: API_SMART,
    url: "/Common/GetProvinceCity",
    method: "get",
    params,
  });
}
//获取媒体数据
export function GetMedia(params) {
  return fetch({
    baseURL: API_SMART,
    url: "/Common/GetMedia",
    method: "get",
    params,
  });
}
//获取数据源数据
export function GetSource(params) {
  return fetch({
    baseURL: API_SMART,
    url: "/Common/GetSource",
    method: "get",
    params,
  });
}
//获取信源数据
export function GetCustomSourceList(params) {
  return fetch({
    baseURL: API_SMART,
    url: "/Common/GetCustomSourceList",
    method: "get",
    params,
  });
}
// 获取核心词
export function GetCoreWord(params) {
  return fetch({
    baseURL: API_SMART,
    url: "/Search/GetCoreWord",
    method: "get",
    params,
  });
}
// 文章详情文章信息
export function GetArticleProperty(params) {
  return fetch({
    baseURL: API_SMART,
    url: "/Search/GetArticleProperty",
    method: "get",
    params,
  });
}
// 栏目接口
export function GetChannelArticleList(data) {
  return fetch({
    baseURL: API_SMART,
    url: "/Search/GetChannelArticleList",
    method: "post",
    data,
  });
}
// 宣城热点
export function GetRegionHotArticle(data) {
  return fetch({
    baseURL: API_SMART,
    url: "/Search/GetRegionHotArticle",
    method: "post",
    data,
  });
}
// 文章详情
export function GetJfrbArticle(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/GetArticle",
    method: "get",
    params,
  });
}
// 全文检索
export function GetAdvanced(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/GetAdvanced",
    method: "post",
    data,
  });
}
// 历史记录
export function GetSearchHistory(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/GetSearchHistory",
    method: "get",
    params,
  });
}
// 相似文章
export function GetSameArticles(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/GetSameArticles",
    method: "post",
    data,
  });
}
// 热点文章
export function GetHotArticles(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/GetHotArticles",
    method: "post",
    data,
  });
}
// 删除历史记录
export function ClearSingleHistory(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/ClearSingleHistory",
    method: "delete",
    params,
  });
}
export function SetSearchHistory(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/SetSearchHistory?question=" + data.question,
    method: "post",
    // data,
  });
}
export function GetArticleNameExtraction(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/GetArticleNameExtraction?model=12",
    method: "post",
    data,
  });
}
export function GetSingleArticleAnalyse(params) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/GetSingleArticleAnalyse",
    method: "get",
    params,
  });
}
export function GetQuoteParagraphs(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/GetQuoteParagraphs?id=" + data.id,
    method: "post",
    data,
  });
}
// 获取组织跟表格
export function GetRelations(data, field, question) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbAnalysis/GetRelations?question=" + question + "&field=" + field,
    method: "post",
    data,
  });
}

// 获取地域
export function GetPlace(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbAnalysis/GetPlace",
    method: "post",
    data,
  });
}

// 信息图谱
export function GetEdges(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbAnalysis/GetEdges",
    method: "post",
    data,
  });
}
// new事件脉络
export function NewGetEvents(data) {
  return fetch({
    baseURL: API_BASE,
    url: `/JfrbSearch/GetEvents?channelId=${data.channelId}`,
    method: "post",
    data,
  });
}
// new事件总结
export function NewGetGetSummary(data) {
  return fetch({
    baseURL: API_BASE,
    url: `/JfrbSearch/GetSummary`,
    method: "post",
    data,
  });
}
// 相关事件
export function GetRelatedArticles(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbSearch/GetRelatedArticles",
    method: "post",
    data,
  });
}
// 获取文章详情1
export function V1GetArticleList(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/v1/Search/GetArticleList",
    method: "post",
    data,
  });
}
// 获取文章详情2
export function GetClueArticleList(params, data) {
  return fetch({
    baseURL: API_BASE,
    url: `/v1/Search/GetClueArticleList?ids=${params}`,
    method: "post",
    data,
  });
}
// 获取知识图谱
export function GetGraphs(
  minNodeNumber,
  minSimilarity,
  minVectorSimilarity,
  filterMaxNodeLink,
  data,
) {
  return fetch({
    baseURL: API_BASE,
    url: `/JfrbAnalysis/GetGraphs?minNodeNumber=${minNodeNumber}&minSimilarity=${minSimilarity}&minVectorSimilarity=${minVectorSimilarity}&filterMaxNodeLink=${filterMaxNodeLink}`,
    method: "post",
    data,
  });
}
// 提交日志文件到服务器
export function Post2Samba(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbAnalysis/Post2Samba",
    method: "post",
    data,
  });
}
// 新的信息图谱
export function CrossCommunity(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbAnalysis/CrossCommunity",
    method: "post",
    data,
  });
}

// 新的事件脉络
export function ClassifyEventTime(data) {
  return fetch({
    baseURL: API_BASE,
    url: "/JfrbAnalysis/ClassifyEventTime",
    method: "post",
    data,
  });
}
//  解放专用-获取实体关系-流程拆分
export function GetEntities(params, data) {
  return fetch({
    baseURL: API_BASE,
    url: `/JfrbAnalysis/GetEntities?modelEnum=${params}`,
    method: "post",
    data,
  });
}
//  解放专用-获取知识图谱-流程拆分
export function GetGraphsFromEntities(
  minNodeNumber,
  minSimilarity,
  minVectorSimilarity,
  modelEnum,
  filterMaxNodeLink,
  data,
) {
  return fetch({
    baseURL: API_BASE,
    url: `/JfrbAnalysis/GetGraphsFromEntities?minNodeNumber=${minNodeNumber}&minSimilarity=${minSimilarity}&minVectorSimilarity=${minVectorSimilarity}&modelEnum=${modelEnum}&filterMaxNodeLink=${filterMaxNodeLink}`,

    method: "post",
    data,
  });
}
